import React from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import Button from "@material-ui/core/Button";
import {Transition} from "react-transition-group";
import {InfoWindow} from "react-google-maps";
import MarkerWithLabel from "react-google-maps/lib/components/addons/MarkerWithLabel";
import {arrayToPoint} from "../../lib/google-maps";
import {Subscribe, appContainer} from "../../contexts/app";
import Infographic from "../Infographic";
import "./style.scss";

export class MapMarker extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      infoWindowOpen: this.props.open || false,
      labelOpen: false,
      infographics: []
    };
  }

  async componentDidMount() {
    let infographics = await this.props.marker.infographics();
    this.setState({infographics});
  }

  handleMarkerClose() {
    this.setState({infoWindowOpen: false});
  }

  handleMarkerToggle() {
    let {infographics} = this.state;
    if (infographics.length) {
      this.setState({
        infoWindowOpen: !this.state.infoWindowOpen
      });
    }
  }

  onMouseOver() {
    this.setState({labelOpen: true});
  }

  onMouseOut() {
    this.setState({labelOpen: false});
  }

  render() {
    const {marker} = this.props;
    const {infoWindowOpen, labelOpen, infographics} = this.state;
    const position = arrayToPoint(marker.geo.coordinates);
    const labelStyle = Object.assign({}, style.label, {
      display: labelOpen ? "block" : "none"
    });
    const isSmallScreen = window.innerWidth <= 700;
    return (
      <div>
        <MarkerWithLabel
          // Set all markers zIndex to the same
          // This allows marker labels to render over
          // a nearby marker image when hovered.
          zIndex={1}
          cursor={infographics.length ? "pointer" : "default"}
          position={position}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onClick={this.handleMarkerToggle}
          icon={marker.type().image.path}
          labelAnchor={new window.google.maps.Point(0, 0)}>
          <div style={labelStyle}>{marker.name}</div>
        </MarkerWithLabel>
        {infoWindowOpen && !isSmallScreen && (
          <InfoWindow
            // minWidth={100}
            onCloseClick={this.handleMarkerClose}
            position={position}
            options={{pixelOffset: new window.google.maps.Size(0, -41)}}>
            <div>
              {infographics.map(infographic => (
                <Infographic infographic={infographic} key={infographic._id} />
              ))}
            </div>
          </InfoWindow>
        )}
        {/* This component cannot be short circuited because it needs to
         remain on the dom for animation purposes
         */}
        <Transition
          in={infoWindowOpen && isSmallScreen}
          timeout={250} // length of .animate class transition
          mountOnEnter
          unmountOnExit>
          {animation => {
            let animationClass;
            if (animation === "entering") {
              animationClass = "slideInUp";
            } else if (animation === "exiting") {
              animationClass = "slideOutDown";
            }
            // NOTE: this markup has some pretty specific styling rules
            // to get the positioning and animations just right. Be
            // weary of moving DOM nodes and styles.
            return (
              <div>
                <div onClick={this.handleMarkerClose} id="mobileInfoWindow" className={`animated ${animationClass}`}>
                  <div className="animation-padder" />
                  <div className="content">
                    {infographics.map(infographic => (
                      <Infographic infographic={infographic} key={infographic._id} />
                    ))}
                  </div>
                </div>
                <div id="mobileInfoFooter" className={`animated ${animationClass}`}>
                  <Button color="primary" onClick={this.handleMarkerClose}>
                    Close
                  </Button>
                </div>
              </div>
            );
          }}
        </Transition>
      </div>
    );
  }
}

MapMarker.propTypes = {
  marker: PropTypes.object.isRequired,
  open: PropTypes.bool
};

const style = {
  label: {
    padding: 7.5,
    backgroundColor: "#fff",
    borderRadius: 2,
    fontSize: 12
  }
};

export default props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return <MapMarker {...props} />;
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/MapMarker/index.jsx